import type { TransformedGame } from "@/hooks/useLiveGames";

// Curated fallback for the 2026 Stanley Cup Final is DISABLED.
// The series has concluded; returning curated fixtures here produced misleading
// 0-0 placeholder "results" for past games. Real games now come from API-Sports.

export function getCuratedStanleyCupFixturesForLocalDate(
  _localDate: string
): TransformedGame[] {
  return [];
}

export function hasCuratedStanleyCupFixturesForLocalDate(_localDate: string): boolean {
  return false;
}
